import { useState } from "react";
import { useLocation } from "react-router-dom";
import { MdOutlineFeedback } from "react-icons/md";
import { useUser } from "../../context/UserContext";
import { PILL_HIDDEN_PATHS } from "../AddBanksPill/AddBanksPill";
import FeedbackModal from "../Modal/FeedbackModal";
import "./FeedbackPill.scss";

/** Top bar shortcut for students to send us free-text feedback. */
const FeedbackPill = () => {
  const { user } = useUser();
  const { pathname } = useLocation();
  const [showModal, setShowModal] = useState(false);

  const isInSession = PILL_HIDDEN_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
  if (user?.type !== "student" || isInSession) {
    return null;
  }

  return (
    <>
      <button type="button" className="feedback-pill" onClick={() => setShowModal(true)} aria-label="Give feedback">
        <MdOutlineFeedback className="feedback-pill__icon" aria-hidden="true" />
        <span className="feedback-pill__text">Have feedback?</span>
      </button>
      <FeedbackModal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
};

export default FeedbackPill;
